import React from 'react';
import { Target, Users, Globe } from 'lucide-react';

const About = () => {
    return (
        <div className="min-h-screen bg-hue-bg font-roboto text-hue-font pb-20">
            {/* Hero */}
            <div className="bg-hue-purple text-white pt-32 pb-20 rounded-b-[3rem] px-6 text-center relative overflow-hidden">
                <h1 className="text-5xl md:text-7xl font-black mb-6 relative z-10">Sobre Hue</h1>
                <p className="text-xl md:text-2xl font-medium opacity-90 max-w-2xl mx-auto relative z-10">
                    Reimaginando cómo las comunidades interactúan con sus ciudades.
                </p>
                <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/10"></div>
            </div>

            {/* Mission */}
            <div className="max-w-5xl mx-auto px-6 py-20">
                <div className="grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <h2 className="text-3xl md:text-4xl font-black mb-6">Nuestra Misión</h2>
                        <p className="text-lg text-slate-600 leading-relaxed mb-6">
                            En Hue, creemos que cada vecino tiene el poder de transformar su entorno. Nuestra misión es empoderar a las comunidades con herramientas simples y efectivas para reportar, gestionar y resolver problemas locales.
                        </p>
                        <p className="text-lg text-slate-600 leading-relaxed">
                            Queremos eliminar la burocracia y crear un canal directo entre las personas y quienes toman las decisiones, fomentando la transparencia y la colaboración.
                        </p>
                    </div>
                    <div className="bg-white rounded-[2.5rem] p-8 shadow-xl border border-slate-100 rotate-2 hover:rotate-0 transition duration-500">
                        <div className="bg-hue-light-blue rounded-2xl p-12 flex items-center justify-center">
                            <Target size={80} className="text-hue-purple" />
                        </div>
                    </div>
                </div>
            </div>

            {/* Values Grid */}
            <div className="bg-white py-20 px-6">
                <div className="max-w-6xl mx-auto">
                    <h2 className="text-3xl font-black text-center mb-16">Nuestros Valores</h2>
                    <div className="grid md:grid-cols-3 gap-8">
                        <div className="text-center p-6">
                            <div className="w-20 h-20 bg-hue-olive/20 rounded-full flex items-center justify-center mx-auto mb-6 text-hue-dark-text">
                                <Users size={40} />
                            </div>
                            <h3 className="text-xl font-bold mb-3">Comunidad Primero</h3>
                            <p className="text-slate-500">
                                Todo lo que hacemos está diseñado para fortalecer los lazos vecinales y mejorar la calidad de vida.
                            </p>
                        </div>
                        <div className="text-center p-6">
                            <div className="w-20 h-20 bg-hue-light-blue rounded-full flex items-center justify-center mx-auto mb-6 text-hue-purple">
                                <Globe size={40} />
                            </div>
                            <h3 className="text-xl font-bold mb-3">Transparencia Total</h3>
                            <p className="text-slate-500">
                                Creemos en datos abiertos y procesos claros. Sin cajas negras, solo resultados visibles.
                            </p>
                        </div>
                        <div className="text-center p-6">
                            <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-6 text-orange-600">
                                <Target size={40} />
                            </div>
                            <h3 className="text-xl font-bold mb-3">Acción Inmediata</h3>
                            <p className="text-slate-500">
                                La tecnología debe servir para acelerar soluciones, no para crear más trámites.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
